import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const homeFaqs = [
  {
    question: "How long does a typical roof replacement take?",
    answer:
      "Most residential roof replacements are completed in 1-3 days, depending on the size of your home and weather conditions. We work efficiently to minimize disruption to your daily routine.",
  },
  {
    question: "Do you offer free estimates?",
    answer:
      "Yes! We provide free, no-obligation estimates for all our services. You can schedule online or call us at (612) 298-9865 to set up a convenient time for your inspection.",
  },
  {
    question: "Are you licensed and insured?",
    answer:
      "Absolutely. Cedar Creek Construction is fully licensed (License #BC645307) and insured. We carry comprehensive liability and workers' compensation coverage for your protection.",
  },
  {
    question: "What areas do you serve?",
    answer:
      "We proudly serve the Minneapolis-St. Paul metro area including Anoka, Andover, Saint Francis, Bethel, Cedar, Isanti, Cambridge, and surrounding Minnesota communities.",
  },
  {
    question: "Do you help with insurance claims?",
    answer:
      "Yes, we have extensive experience working with insurance companies on storm damage claims. We'll document the damage, provide detailed estimates, and work directly with your adjuster to make the process as smooth as possible.",
  },
  {
    question: "What roofing materials do you offer?",
    answer:
      "We install a variety of high-quality roofing materials including architectural shingles, metal roofing, and specialty options. We work with trusted brands like GAF, Owens Corning, and CertainTeed to ensure lasting protection.",
  },
  {
    question: "How do I know if I need a roof repair or full replacement?",
    answer:
      "Our experts will conduct a thorough inspection to assess the condition of your roof. Factors like the age of your roof, extent of damage, and overall wear help us recommend the most cost-effective solution for your situation.",
  },
  {
    question: "Do you offer financing options?",
    answer:
      "Yes, we offer flexible financing options to help make your home improvement project affordable. Contact us to learn about our current financing programs and find a payment plan that works for your budget.",
  },
];

export const HomeFAQ = () => {
  return (
    <>
      <section className="py-20 bg-background">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <span className="section-badge">Got Questions?</span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground mt-4 mb-4">
              Frequently Asked Questions
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Find answers to common questions about our roofing and exterior
              services.
            </p>
          </div>

          <div className="max-w-3xl mx-auto">
            <Accordion type="single" collapsible className="space-y-4">
              {homeFaqs.map((faq, index) => (
                <AccordionItem
                  key={index}
                  value={`item-${index}`}
                  className="bg-card border border-border rounded-xl px-6 data-[state=open]:border-secondary"
                >
                  <AccordionTrigger className="text-left font-heading font-semibold text-foreground hover:text-secondary py-5">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground pb-5">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </section>
    </>
  );
};
